import useSWR from 'swr';
import axios from 'axios';
import { List } from 'ui/components';

export interface NewsListProps {
	rootFolder?: Umbraco.NewsPage;
	count?: number;
	offset?: number;
	link?: Umbraco.Link;
}

export const NewsList: React.FC<NewsListProps> = ({ rootFolder, count, offset, link }) => {
	const rootIdQuery = rootFolder ? `rootIds:[${rootFolder.id}]` : '';
	const limitQuery = count === 0 ? '' : `limit:${count}`;
	const offsetQuery = offset >= 0 ? `offset:${offset}` : '';

	const query = `{
		pageSearch(documentType:["newsPage"] ${rootIdQuery} ${limitQuery} ${offsetQuery})
			{
				pages {
					name
					url
					id
					properties
				}
			}
		}`;

	const fetcher = (url) =>
		axios({
			url: url,
			method: 'POST',
			data: {
				query,
			},
		}).then((res) => res.data);

	const { data } = useSWR(`/api/graphQLContent`, fetcher);

	if (!data) return null;

	const listItems: Models.BlurbCard[] = data.pageSearch?.pages?.map(
		(
			result,
			// index
		) => {
			const returnValue: Models.BlurbCard = {
				date: result.properties.newsDate,
				text: result.properties.newsTeaser,
				link: result.url,
				heading: result.properties.newsHeading,
				settings: {
					properties: {
						desktopWidth: '50',
						mobileWidth: '50',
					},
				},
			};
			return returnValue;
		},
	);

	return <List items={listItems} desktopWidth="100" mobileWidth="100" link={link}></List>;
};
